import { displayValue } from './month';

export const CompanyType: displayValue[] = [
  { value: '1', display: 'Carrier - TL' },
  { value: '2', display: 'Carrier - LTL' },
  { value: '3', display: 'Company Driver' },
  { value: '4', display: 'Owner Operator' },
  { value: '5', display: 'Brokerage' },
  { value: '6', display: 'Manufacturer' },
  { value: '7', display: 'Logistics' },
  { value: '8', display: 'Consultant' },
  { value: '9', display: 'Courier' },
  { value: '10', display: 'Developer' },
  { value: '11', display: 'Freight Forwarder' },
  { value: '12', display: 'Government' },
  { value: '13', display: 'Intermodal' },
  { value: '14', display: 'Private Fleet' },
  { value: '15', display: 'Shipper' },
  { value: '16', display: 'Other' },
];

export function getCompanyType(key: string): string {
  const result = CompanyType.find((item) => {
    return item.value === key;
  });
  return result.display;
}
